import { render, staticRenderFns } from "./PopupWindowExtends.vue?vue&type=template&id=f096c4c0&"
import script from "./PopupWindowExtends.vue?vue&type=script&lang=js&"
export * from "./PopupWindowExtends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PopupWindowExtends.vue"
export default component.exports